import React from 'react';
import PropTypes from 'prop-types';

import slug from '@gumtree/ui-library/src/utils/slug';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';
import TopSearchesSection from './top-searches-section';

import { TopSearchesContent } from './top-search-style';
import { ModernTopSearchesContainer } from './top-search-modern.style';

const TopSearchesTabSection = ({ sections, title, modern = false }) => {
    const content = (
        <>
            <h2 {...qaAttribute(`top-searches-toggler-${slug(title)}`)}>{title}</h2>
            <TopSearchesContent>
                {sections.map((section, index) => (
                    <TopSearchesSection key={index} {...section} />
                ))}
            </TopSearchesContent>
        </>
    );

    return modern ? <ModernTopSearchesContainer>{content}</ModernTopSearchesContainer> : content;
};

TopSearchesTabSection.propTypes = {
    sections: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    modern: PropTypes.bool,
};

export default TopSearchesTabSection;
